var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHandCash = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2098 13.2812H20.241L20.7316 14.1063C20.9567 14.4441 20.9567 14.884 20.7316 15.2219L20.4191 15.6875C20.219 15.9877 20.1952 16.3721 20.3566 16.6948L20.8775 17.7365C21.0191 18.0197 21.0191 18.3532 20.8775 18.6365L20.2827 19.825C20.1637 20.0636 20.1442 20.3397 20.2285 20.5927L20.4025 21.1135C20.5236 21.4749 20.4296 21.8736 20.1598 22.1427L18.6785 23.4375H11.6264C11.2428 23.4374 10.8628 23.5106 10.5066 23.6531L8.52747 24.2188",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4906 18.1842L4.86769 16.9176C5.28671 16.7594 5.64112 16.4662 5.87498 16.0842L8.04685 11.0613C8.27488 10.6906 8.5805 10.3736 8.94269 10.1322L9.69894 9.62695",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1388 12.7135L8.52835 1.43021C8.50442 1.26716 8.55265 1.10178 8.66047 0.977156C8.76829 0.852533 8.92502 0.781018 9.08981 0.781251H16.9565",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4894 13.2813L12.6082 4.52188C12.5924 4.37446 12.6403 4.22733 12.7397 4.11736C12.8392 4.00739 12.9807 3.945 13.129 3.94584H20.3165C20.4697 3.94401 20.616 4.00975 20.7163 4.12555C20.8167 4.24136 20.8609 4.39547 20.8373 4.54688L19.5269 13.2813",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5374 8.98047C16.7525 8.98048 16.9272 9.15453 16.928 9.36972C16.9287 9.58491 16.7553 9.76018 16.5401 9.76171C16.3249 9.76324 16.149 9.59044 16.1467 9.37526C16.1467 9.15952 16.3216 8.98464 16.5374 8.98464",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHandCash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HandCash.54515bfa120e5312ac9bd877e6bd3be3.svg";